import React from 'react';

import styled from '@emotion/styled';

import { IconProps } from '../../IconsProps';

const StyledCopy = styled.svg<IconProps>`
  & .cls-1,
  .cls-3 {
    fill: none;
  }

  & .cls-2 {
    fill: var(--chatbot-color-primary, #404040);
  }

  & .cls-3 {
    stroke: var(--chatbot-color-primary, #404040);
  }

  & .cls-4 {
    stroke: none;
  }

  &.hover:hover,
  &.active {
    .cls-1 {
      fill: none;
    }

    .cls-2,
    .cls-3 {
      fill: var(--du-color-primary, #128370);
    }

    .cls-3 {
      stroke: var(--du-color-primary, #128370);
    }

    .cls-4 {
      stroke: none;
    }
  }
`;

const CopyIcon: React.FC<IconProps> = ({ active }) => {
  let activeclass = active ? 'active' : '';
  const isTouch = !!('ontouchstart' in window) || window.navigator.maxTouchPoints > 0;
  activeclass = `${activeclass} ${!isTouch ? 'hover' : ''}`;

  return (
    <StyledCopy
      id='Copy-Icon'
      xmlns='http://www.w3.org/2000/svg'
      width='32'
      height='32'
      viewBox='0 0 32 32'
      className={activeclass}
    >
      <path id='Margin' className='cls-1' d='M0,0H32V32H0Z' />
      <path
        id='Path_15963'
        data-name='Path 15963'
        className='cls-2'
        d='M14.182,2H5.455A1.454,1.454,0,0,0,4,3.455V13.636H5.184V3.144h9Z'
        transform='translate(5.091 6)'
      />
      <g id='Rectangle_7262' data-name='Rectangle 7262' className='cls-3' transform='translate(12 11)'>
        <rect className='cls-4' width='11' height='13' rx='1' />
        <rect className='cls-1' x='0.5' y='0.5' width='10' height='12' rx='0.5' />
      </g>
    </StyledCopy>
  );
};

export default CopyIcon;
